// fr_pms_live_board.ts
// Tłumaczenia dla PMS.LiveBoard.Dashboard.tsx

export const frPmsLiveBoard = {

  title:         "Live Board",
  managerView:   "Tableau de bord du manager",
  newReservation:"Nouvelle reservation",
  today:         "Aujourd'hui",

  // ── Kafelki główne ───────────────────────────────────────────────────────
  tiles: {
    occupancySold: "Occupation (vendue pour cette nuit)",
    inHouseNow: "Clients présents (actuellement)",
    readyToSell: "Prêtes à vendre",
    soldTonight: "Vendues pour cette nuit : {{occupied}} / {{sellable}} chambres vendables",
    notAvailable: "Indisponible",
    ofTotal: "{{percent}}% du total",
    needsActionWithRoutine: "Action requise · {{count}} états courants",
    inHouseNowHint: "Clients actuellement présents, y compris les départs du jour",
    occupancy:   "Occupation",
    arrivals:    "Arrivees",
    departures:  "Departs",
    inHouse:     "En sejour",
    readyRooms:  "Gotowe pokoje",
    openIssues:  "Problemes ouverts",
  },

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    housekeeping: "Housekeeping",
    frontDesk:    "Reception",
    billing:      "Facturation",
  },

  // ── Przyciski operacji ───────────────────────────────────────────────────
  actions: {
    checkIn:        "Enregistrer l'arrivee",
    checkInNow:     "Enregistrer l'arrivee maintenant",
    checkOut:       "Enregistrer le depart",
    confirmCheckIn: "Confirmer l'arrivee",
    confirmCheckOut:"Confirmer le depart",
    confirmMove:    "Confirmer le deplacement",
    earlyCheckIn:   "Arrivee anticipee",
    lateCheckOut:   "Depart tardif",
    roomMove:       "Changement de chambre",
    walkIn:         "Sans reservation",
    approve:        "Approuver",
    addNote:        "Ajouter une note",
    saveNote:       "Enregistrer la note",
  },

  // ── Notatka ──────────────────────────────────────────────────────────────
  noteQuestion: "Que doit savoir l'equipe ?",

  // ── Statusy i wyniki akcji ───────────────────────────────────────────────
  messages: {
    checkInSuccessful:       "Arrivee terminee avec succes",
    checkInFailed:           "Arrivee echouee",
    checkOutSuccessful:      "Depart termine avec succes",
    checkOutFailed:          "Depart echoue",
    checkInNotPossible:      "L'arrivee n'est pas possible avant la date d'arrivee",
    lateCheckoutFailed:      "Depart tardif echoue",
    lateCheckoutUntil:       "Depart tardif jusqu'a ",
    roomMoveCompleted:       "Changement de chambre termine",
    roomMoveFailed:          "Changement de chambre echoue",
    roomMovePrefix:          "Deplacement : ",
    noteAdded:               "Note ajoutee",
    failedToAddNote:         "Impossible d'ajouter la note",
    alertDismissed:          "Alerte ignoree",
    approved:                "Approuve",
    approvedFromLiveBoard:   "Approuve depuis le Live Board",
    paymentPosted:           "Paiement enregistre",
    chargePosted:            "Frais enregistres",
    housekeepingTaskCreated: "Tache housekeeping creee",
    incidentResolved:        "Incident resolu",
    reservationCreated:      "Reservation creee",
    walkInCheckedIn:         "Sans reservation enregistre : ",
    walkInFailed:            "Sans reservation echoue",
    walkInReservationCreated:"Reservation sans reservation creee",
    roomStatusUpdated:       "Statut de la chambre mis a jour",
    failedToUpdateRoom:      "Impossible de mettre a jour la chambre",
    failedToUpdateRoomStatus:"Impossible de mettre a jour le statut de la chambre",
    failedToUpdateIncident:  "Impossible de mettre a jour l'incident",
    failedToAssign:          "Impossible d'assigner",
    noPropertySelected:      "Aucun etablissement selectionne",
    noPendingArrivals:       "Aucune arrivee en attente",
    noPendingDepartures:     "Aucun depart en attente",
    needsAction:             "Necessite une action",
  },

  // ── Etykiety tabelki/kart ─────────────────────────────────────────────────
  labels: {
    floor:    "Etage ",
    room:     "Chambre ",
    guest:    "Client",
    guestsNow:"Clients maintenant",
    fullName: "Nom complet",
    standard: "Standard",
    nights:   "Nuits",
  },

} as const;

export default frPmsLiveBoard;
